var fn = function( obj ){
var __t,__p='';
__p+='\nuniform float uStrength;\nvarying vec2 vTexCoords;\n\nvoid main(void){\n  float grad = 1.5 - length( vTexCoords )*.7;\n  gl_FragColor = vec4(uStrength*grad);\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;